import fontFace from './font-face.js';
import importAtrule from './import.js';
import media from './media.js';
import nest from './nest.js';
import page from './page.js';
import supports from './supports.js';

export default {
    'font-face': fontFace,
    'import': importAtrule,
    media,
    nest,
    page,
    supports
};
